import React from 'react'
import { Checkbox } from "../../../components/checkbox/checkbox"
import { CustomIcon } from "../../../components/customIcon/customIcon"
import { useDispatch, useSelector } from "../../../hooks/redux"
import { toggleSortOrder, selectAllUsers, toggleTokensVisible } from "../../../store/slices/admin/adminSlice"
import classes from '../../../styles/admin/usersList.module.scss'
import cn from 'classnames'


export const UsersListHeader: React.FC<{ allIds: number[] }> = ({ allIds }) => {
    const dispatch = useDispatch()
    const sortOrder = useSelector((state) => state.admin.filters.sortOrder)
    const selectedUsers = useSelector((state) => state.admin.selectedUsers)
    const tokensVisible = useSelector((state) => state.admin.tokensVisible)
    const allSelected = allIds.length > 0 && allIds.every(id => selectedUsers.includes(id))

    return (
        <div className={classes.usersListHeader}>
            <span className={classes.usersListHeaderNum}>#</span>
            <Checkbox isChecked={allSelected} handleCheckboxChange={() => dispatch(selectAllUsers(allIds))} />
            <button
                className={cn(classes.usersListHeaderCell, classes.sortableCell)}
                onClick={() => dispatch(toggleSortOrder())}
            >
                Имя
                <span className={cn(classes.sortIcon, sortOrder !== 'none' && classes.sortIconActive)}>
                    {sortOrder === 'desc'
                        ? <CustomIcon icon="arrowDown" />
                        : <CustomIcon icon="arrowUp" />
                    }
                </span>
            </button>
            <span className={classes.usersListHeaderTokenActions} />
            <button
                className={cn(classes.usersListHeaderCell, classes.sortableCell, classes.usersListHeaderToken)}
                onClick={() => dispatch(toggleTokensVisible())}
            >
                <CustomIcon icon={tokensVisible ? 'hideIcon' : 'showIcon'} />
                Токен
            </button>
            <span className={classes.usersListHeaderCell}>Доступы</span>
        </div>
    )
}
